export default __webpack_public_path__ + "static/media/near03.66b2b744.png";